import { useRouter } from "next/router";
import { usersApi } from "src/service/UsersApi";
import { store } from "src/store";

export const PAGE_TITLE_ITEM = [
  { label: "マイページ", path: "mypage" },
  { label: "", path: "other" },
  { label: "セッション", path: "session" },
  { label: "フムフム", path: "fumufumu" },
  { label: "クローゼット", path: "closet" },
  { label: "マップ", path: "map" },
  { label: "メンバー一覧", path: "member" },
  { label: "ランキング", path: "ranking" },
  { label: "ステータス", path: "status" },
  { label: "はたらくチャレンジ", path: "challenge" },
  { label: "はたらくマインド", path: "mind" },
  { label: "ミッション", path: "mission" },
  { label: "バッジ", path: "badge" },
  { label: "ショップ", path: "shop" },
  { label: "スタイル", path: "style" },
  { label: "アカウント情報設定", path: "setting" },
  { label: "ガイドライン", path: "guideline" },
  { label: "メールアドレス変更", path: "alteration" },
  { label: "マイキャリアパス", path: "my-career-path" },
  { label: "ログイン", path: "signin" },
  { label: "特定商取引法に基づく表示", path: "commerce_law" },
  { label: "アカウントを作成", path: "signup" },
  { label: "利用規約", path: "terms_of_use" },
];

export const ADMIN_PAGE_TITLE_ITEM = [
  { label: "コーチ用セッション", path: "coach", root: "admin" },
  { label: "ユーザー一覧", path: "userliset", root: "admin" },
  { label: "セッション", path: "session", root: "admin" },
  { label: "実施セッション", path: "implementsession", root: "admin" },
  { label: "コーチ一覧", path: "coachlist", root: "admin" },
  { label: "未承認ユーザー一覧", path: "unapproveduserlist", root: "admin" },
  { label: "未承認コーチ一覧", path: "unapprovedcoach", root: "admin" },
  { label: "カテゴリー", path: "category", root: "admin" },
  { label: "クラス", path: "class", root: "admin" },
  { label: "コース", path: "course", root: "admin" },
  { label: "開催場所", path: "venue", root: "admin" },
  { label: "Metalife", path: "metalife", root: "admin" },
  { label: "開催場所", path: "venue", root: "admin" },
  { label: "ワークシート一覧", path: "worksheet", root: "admin" },
  { label: "はたらくマインド一覧", path: "mind", root: "admin" },
  { label: "お申し込み一覧", path: "entry", root: "admin" },
  { label: "招待コード一覧", path: "invitation-codes", root: "admin" },
  { label: "体験会希望日時一覧", path: "entry-datetimes", root: "admin" },
  { label: "通知管理一覧", path: "notification-triggers", root: "admin" },
  { label: "CSVエクスポート", path: "csv-export", root: "admin" },
] as const;

export const usePageTitle = () => {
  const router = useRouter();
  const pathArray = router.asPath.split("/") || [];

  const headPageItem = PAGE_TITLE_ITEM.filter((item) => {
    return item.path === pathArray[1];
  });

  if (headPageItem.length === 0) {
    return "TANQ BASE";
  }
  if (headPageItem[0].path === "other") {
    const user = usersApi.endpoints.getUser.select(router.query?.id as string)(
      store.getState(),
    );
    return user.data?.nickname;
  }

  return headPageItem[0].label;
};

export const useAdminPageTitle = (path: string) => {
  const pathArray = path.split("/") || [];

  const headPageItem = ADMIN_PAGE_TITLE_ITEM.filter((item) => {
    return pathArray[2] && item.path === pathArray[2];
  });

  if (headPageItem.length === 0) {
    return "運営";
  }

  return headPageItem[0].label;
};
